import YandexMap from "../../ymap";
import {findID, output_roubles} from "../../../../../../../modules/vegas/js/util";

function onReady() {
	let map = findID('yaMapCourier');
	if (map) {
		let zones = JSON.parse(map.dataset.zones);
		let myMapCourier;

		new YandexMap().include(() => {
			myMapCourier = new ymaps.Map('yaMapCourier', {
				center: [54.538507, 36.262588],
				zoom: 11,
				controls: ['smallMapDefaultSet'],
			});

			myMapCourier.behaviors.disable('scrollZoom');
			myMapCourier.controls.remove('geolocationControl');
			myMapCourier.controls.remove('searchControl');
			myMapCourier.controls.remove('typeSelector');
			myMapCourier.controls.remove('fullscreenControl');

			zones.forEach(zone => {
				let myPolygon = new ymaps.Polygon(zone.config.coordinates, {}, {
					fillColor: '#00FF0020',
					strokeColor: '#f00',
					strokeWidth: 2
				});

				myPolygon.properties.set('balloonContent', (function () {
					let text = '';

					if (typeof zone.price !== 'undefined') {
						let priceText = zone.price > 0 ? output_roubles(zone.price) : 'Бесплатно';
						text += '<p>Стоимость доставки: <strong>' + priceText + '</strong></p>';
					}

					if (typeof zone.price_min_free !== 'undefined') {
						let minFreeText = output_roubles(zone.price_min_free)
						text += '<p>Бесплатно при заказе от <strong>' + minFreeText + '</strong></p>';
					}

					return text;
				})());

				myMapCourier.geoObjects.add(myPolygon);
			})
		});
	}
}

document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);
